import Spinner from 'components/shared/app/Spinner';
import { ErrorMessages } from 'lib/AppErrors';
import Config from 'lib/Config';
import Button from 'components/shared/app/Button';
import Logo from 'components/shared/app/Logo';
import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { ValidationUtils } from 'lib/utils/Validation';
import { Link, useParams } from 'react-router-dom';
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';
import './style.scss';

const AcceptInvite = (props) => {
    const params = useParams();
    const token = params.token;
    const inputName = React.createRef();
    const inputPassword = React.createRef();
    const inputRePassword = React.createRef();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const submitRegister = () => {
        if (inputName.current && inputPassword.current && inputRePassword.current) {
            const name = inputName.current.value;
            const password = inputPassword.current.value;
            const rePassword = inputRePassword.current.value;

            if (!name || !password || !rePassword) {
                return setError('Please enter your name and password.');
            }
            if (password !== rePassword) {
                return setError('Please make sure your passwords match.');
            }
            if (password.length < 8) {
                return setError("Password must be at least 8 letters.");
            }
            if (!ValidationUtils.isStrongPassword(password)) {
                return setError(ErrorMessages.passwordValidationError(password));
            }

            setLoading(true);
            props.auth
                .acceptInvite(token, name, password)
                .then((r) => {
                    setSuccess(true);
                })
                .catch(e => {
                    setError(e.error || 'An error occurred.');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const onEnter = (e) => {
        if (e.keyCode == 13) {
            submitRegister();
        }
    };

    return (
        <div className="accept-container center flex-col-center-both col-single pad-default">
            <Helmet><title>Welcome to {Config.SITE_TITLE_PREFIX}</title></Helmet>
            <div className="logo">
                <Logo symbol />
            </div>
            <div className="register-content">
                {success ? (
                    <div className="success">
                        <h3>Thank you!</h3>
                        <p>Please login to continue.</p>
                        <Link to="/login">
                            <Button round simple bold filled center color="white" textPosition="center">
                                Login
                            </Button>
                        </Link>
                    </div>
                ) : (
                    <form className="accept-form">
                        <div className="input-row pad lg ns">
                            <input
                                type="text"
                                placeholder="Name*"
                                autoComplete="off"
                                ref={inputName}
                                className="input simple"
                                onKeyUp={onEnter}
                            />
                        </div>
                        <div className="input-row pad lg ns">
                            <input
                                type="password"
                                placeholder="Password *"
                                autoComplete="off"
                                ref={inputPassword}
                                className="input simple"
                                onKeyUp={onEnter}
                            />
                        </div>
                        <div className="input-row pad lg ns">
                            <input
                                type="password"
                                placeholder="Re-Enter Password *"
                                autoComplete="off"
                                ref={inputRePassword}
                                className="input simple"
                                onKeyUp={onEnter}
                            />
                        </div>
                        <div className="button-row pad lg ns">
                            <Button
                                round
                                simple
                                bold
                                filled
                                center
                                color="white"
                                icon={loading ? <Spinner size="small fit" className="icon" color="blue" /> : <img src={arrowIcon} />}
                                iconPosition="right"
                                textPosition="center"
                                onClick={(e) => submitRegister()}>
                                Register
                            </Button>
                        </div>
                        {error && <div className="error pad sm">{error}</div>}
                    </form>
                )}
            </div>
        </div>
    );
};

export default AcceptInvite;